import ModalBackdrop from '../ModalBackdrop'

/** Ending a rivalry is destructive enough to confirm — starting one isn't, so
 * the Challenge button fires `onRivalAction` straight through instead. */
function EndRivalryConfirmModal({
  rivalName,
  onCancel,
  onConfirm,
}: {
  rivalName: string
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <ModalBackdrop onClose={onCancel}>
      <div className="profile__confirm">
        <p className="profile__confirm-title">End this rivalry?</p>
        <p className="profile__confirm-body">
          You'll stop tracking your head-to-head record with {rivalName}. You can
          challenge them again later.
        </p>
        <div className="profile__confirm-actions">
          <button className="profile__confirm-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button className="profile__confirm-danger" onClick={onConfirm}>
            End rivalry
          </button>
        </div>
      </div>
    </ModalBackdrop>
  )
}

export default EndRivalryConfirmModal
